// extracted by mini-css-extract-plugin
export default {"picture":"Card_picture__fnbvp","featureCard":"Card_featureCard__y7Bwi","img":"Card_img__4BT0e"};